import * as React from 'react';
import { cn } from '@/lib/utils';
import { SocialAvatar } from '@/components/social/SocialAvatar';
import { useBusinessProfile } from '@/hooks/useBusinessProfile';
import { useWorkspaceCustomImage } from '@/hooks/useWorkspaceCustomImage';
import { workspaceInitial } from '@/lib/workspaces/manageWorkspaces';
import type { Workspace } from '@/hooks/useWorkspaces';

export function workspaceAccountId(ws: Workspace | null | undefined): string | null {
  return ws?.whatsapp?.business_account_id || ws?.business_account_id || null;
}

function InitialGlyph({ name, className }: { name?: string; className: string }) {
  return <div className={className}>{workspaceInitial(name)}</div>;
}

export function WorkspaceAvatar({
  accountId,
  workspaceId,
  name,
  sizeClass,
  glyphTextClass = 'text-[11px]',
  rounded = 'rounded-full',
  fallback,
  loading = 'lazy',
}: {
  accountId?: string | null;
  workspaceId?: string | null;
  name?: string;
  sizeClass: string;
  glyphTextClass?: string;
  rounded?: string;
  fallback?: React.ReactNode;
  loading?: 'lazy' | 'eager';
}) {
  const customImage = useWorkspaceCustomImage(workspaceId);
  const { data: profile } = useBusinessProfile(accountId || undefined, {
    enabled: Boolean(accountId),
  });

  const glyphClass = cn(
    'flex shrink-0 items-center justify-center bg-[#1D2939] font-semibold text-white',
    rounded,
    glyphTextClass,
    sizeClass,
  );

  return (
    <SocialAvatar
      src={customImage || profile?.profile_picture_url}
      alt={name || 'Workspace'}
      className={cn('shrink-0 object-cover', rounded, sizeClass)}
      fallback={fallback ?? <InitialGlyph name={name} className={glyphClass} />}
      loading={loading}
    />
  );
}
